export default {
    key: 'first-flyerglider',
    type: 'Activity',
    isUsingProductConfigPresets: false,
    isUsingProductPresets: true,
    hideCrossSells: false,
    disablePassengers: false,
    isLoadingPassengerOffers: true,
    isRental: false,
    activityId: 'c3cb5db5-071a-4e29-9f74-3e20b0f5a758',
    categoryId: undefined,
    defaultDuration: 1440,
    isMultiDay: false,
    isUsingReductionCards: false,
    isUsingKeyCards: false,
    hidePassengerMeasurements: false,
    isUsingPromos: true,
    isPromotionRequired: false,
    showDuration: false,
    upsells: [],
    salesTimeLimit: 660, // 11:00
    isUpsellDatesRestricted: false,
    maxNumberOfPeople: 10,
    maxNumberOfPeopleGroupTariff: undefined,
    isUsingSeasonDates: false,
    defaultPassengerAge: 30,
    hiddenProductReductionCard: undefined,
    listingId: 'c3cb5db5-071a-4e29-9f74-3e20b0f5a758',
    contentfulId: 'first-flyerglider',
    steps: [],
} satisfies ProductConfigActivity;
